import Hero from './assets/Layer_1.png';
import Google from './assets/Google Play.png';
import Store from './assets/App Store.png';
import Eleph from "./assets/elephan.png";
import Vector from "./assets/Vector 1.png";
import Vector1 from "./assets/Vector.png"
import Phone1 from "./assets/Iphone 14 - 2.png";
import Phone2 from "./assets/Iphone 14 - 22.png";
import  FaFacebook  from "./assets/Facebook.png";
import  FaTwitter  from "./assets/Twitter-Icon.png";
import  FaYoutube  from "./assets/Youtube-Icon.png";
import  FaLinkedinIn  from "./assets/LinkedIn.png";
import './App.css';

function App() {
  return (
    <div className="App">
       <section className="hight">
        <div className="text" >
            <h2>It`s time to</h2> 
            <h2>KNOW YOUR FUTURE</h2>
        </div>
        <div className="row_grup">
        <div className="hero">
           <img src={Hero} alt="Hero" />
        </div>
        <div className="download">
            <p>Download NOW!</p>
            <div className="buble-btn">
               <button> 
                <img src={Google} alt="Google" />
               </button>
               <button> 
                <img src={Store} alt="Store" />
               </button>
            </div>
        </div>
        </div>
    </section>
    <div className='row'>
      <hr/>
    </div>
    <section className='info'>
      <div className='title'>
        <h2>Stayone step ahead.</h2>
        <h2>Always.</h2>
      </div>
      <div className="row_grup row_grup2">
        <div className='messeng'>
            <p>Our app is your personal guide to the unseen. With insights drawn from ancient palmistry and modern interpretation, you'll unlock secrets hidden in the lines of your hand.</p>
<p>Discover what the future holds in the key areas of your life:</p>
 <p>💰 Finances – Navigate opportunities and avoid setbacks with foresight.</p>
<p> ❤️ Love – Understand the path of your heart and the people destined to walk it with you.</p>
 <p>🤝 Relationships – Gain clarity in personal connections and grow deeper bonds.</p>

<p>Every prediction is tailored to you—helping you make confident decisions, embrace change, and stay one step ahead in a world full of uncertainty.
Let your hand reveal the future.</p>
        </div>
        <div className='elephant'>
          <img src={Eleph} alt="elephant" />
        </div>
      </div>
    </section>
    <section className='statistics'>
        <div className='statistics-title'>
          <h2>Trusted by Over 200,000 Users</h2>
 
      </div>
      <div className='text_info'>
        <p>Our app has already helped more than 200,000 people avoid unwanted situations in everyday life. Through personalized palm readings, intuitive insights, and guidance on love, money, and relationships — we help you make smarter choices before problems arise. Your future is in your hands. Let us help you read it.</p>
      </div>
        <div className="row_grup">
      <div className='type knewave-regular'>
       <p> It has already saved one of our users from a fatal financial mistake! </p>
       <img src={Vector} alt="arrow" className='arrow' />
       <img src={Vector1} alt="arrow" className='vector' />
      </div>
      <div className='phone'>
        <img src={Phone1} alt="Phone" />
      </div>
      </div>
    </section>
    <section className='final'>
      <div className="row_grup">
        
        <div className='text_block'>
        <div className='info_text'>
           <p> Your hands are not random — they hold the map of your soul.
            From love and career to health and emotional growth, palmistry can help you understand yourself better and make decisions with confidence.</p>
            <p className='toll_text'>Thousands have already changed
            their lives by discovering what their
            palms reveal.
            Ready to see what
            your hand says about you?</p>
          </div>
          <div className='download_block'>
            <div className="row_grup">
            <p>
              Download the app
              and take the first step
              toward clarity, guidance,
              and a future you can shape.
            </p>
                        <div className="buble-btn final_btn">
               <button> 
                <img src={Google} alt="Google" />
               </button>
               <button> 
                <img src={Store} alt="Store" />
               </button>
            </div>
            </div>
          </div>
        </div>
        <div className='img_block'>
          <img src={Phone2} alt="phone" />
        </div>
      </div>
    </section>
    <footer>
      <div className='social'>
      <div className=" social-icon">
        <a href=""><img src={FaFacebook} alt="" />   </a>
        <a href=""><img src={FaTwitter} alt="" /></a>
        <a href=""><img src={FaYoutube} alt="" /></a>
        <a href=""><img src={FaLinkedinIn} alt="" /></a>
    </div>
    <hr />
    </div>
    <p>@ 2023 Palminis</p>
    <p>All Right Reserved</p>
    </footer>
    </div>
  );
}

export default App;
